exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-wrapper {\n  margin-top: 3rem;\n  padding: 0.5rem 1rem;\n}\n@media only screen and (min-width: 1150px) {\n  .content-wrapper {\n    max-width: 1100px;\n    margin: 3rem auto 0 auto;\n  }\n}\n@media only screen and (min-width: 1250px) {\n  .content-wrapper {\n    max-width: 1200px;\n    margin: 3rem auto 0 auto;\n  }\n}\n", ""]);

// exports
